import { Component } from "react";
import { navigate } from "gatsby";
import styles from "./link.module.less";
import { EventAggregator, PrimaryButton, PrimaryButtonLink, extract } from "@parksandresorts/core";
import { GlobalContext } from "components/stores/global-context";

class Link extends Component {
  constructor(props) {
    super(props);

    this.scrollToBlock = this.scrollToBlock.bind(this);
    this.onScrollSection = this.onScrollSection.bind(this);
    this.onScrollTargetBlock = this.onScrollTargetBlock.bind(this);

    this.scrollToBlockTitle = extract(props, "scrollToBlockTitle");
    this.scrollToBlockId = extract(props, "scrollToBlock[0].contentful_id");
    this.contentful_id = props.contentful_id;

    this.internalLinkSlug = extract(props, "internalLink.slug", null);
    this.externalUrl = extract(props, "externalUrl", null);

    this.sectionObserver = null;
    this.targetBlockObserver = null;

    this.state = {
      isSectionInViewport: true,
      isTargetBlockInViewport: false,
    };
  }

  scrollToBlock() {
    if (this.targetBlockElement) {
      const targetBlockRect = this.targetBlockElement.getBoundingClientRect();
      const offsetFromTop = window.scrollY;
      const scrollToPosition = targetBlockRect.top + offsetFromTop - 65;
      window.scrollTo({
        top: scrollToPosition,
        behavior: "smooth",
      });
      EventAggregator.publish("trackEvent", {
        category: "Sticky Button",
        action: "Clicked Button",
        label: this.scrollToBlockId,
      });
    }
  }

  onScroll() {
    this.onScrollSection();
    this.onScrollTargetBlock();
  }

  onScrollSection() {
    const sectionRect = this.sectionElement.getBoundingClientRect();
    const scrolledPassed = sectionRect.top - 96 <= 0 ? true : false; // yPos> sectionRect.top - 64;

    if (scrolledPassed && this.state.isSectionInViewport) {
      this.setState({
        isSectionInViewport: false,
      });
    } else if (!scrolledPassed && !this.state.isSectionInViewport) {
      this.setState({
        isSectionInViewport: true,
      });
    }
  }

  onScrollTargetBlock() {
    if (!this.targetBlockElement) {
      return;
    }

    const targetBlockRect = this.targetBlockElement.getBoundingClientRect();
    const reachedTargetBlock = targetBlockRect.top - 128 <= 0 ? true : false;

    if (reachedTargetBlock && !this.state.isTargetBlockInViewport) {
      this.setState({
        isTargetBlockInViewport: true,
      });
    } else if (!reachedTargetBlock && this.state.isTargetBlockInViewport) {
      this.setState({
        isTargetBlockInViewport: false,
      });
    }
  }

  componentDidMount() {
    this.onScrollSubscription = EventAggregator.subscribe("onScroll", (yPos) => this.onScroll(yPos));
    this.sectionElement = document.querySelector(`[data-contentful-id="${this.contentful_id}"]`);
    this.isSiblingUtilityBlock = this.sectionElement.nextElementSibling.classList.contains("block--with-utility");
    this.targetBlockElement = this.scrollToBlockId
      ? document.querySelector(`[data-contentful-id="${this.scrollToBlockId}"]`)
      : null;
  }

  componentWillUnmount() {
    if (this.onScrollSubscription) {
      this.onScrollSubscription.remove();
    }
  }

  getButton() {
    if (this.internalLinkSlug) {
      return (
        <PrimaryButton
          className={styles.button}
          onClick={() => navigate(this.internalLinkSlug)}
          label={this.props.title}
        />
      );
    }

    if (this.externalUrl) {
      return <PrimaryButtonLink className={styles.button} url={this.externalUrl} label={this.props.title} />;
    }

    if (this.targetBlockElement) {
      return <PrimaryButton className={styles.button} onClick={this.scrollToBlock} label={this.props.title} />;
    }

    return null;
  }

  render() {
    return (
      <section
        data-contentful-id={this.contentful_id}
        className={`block ${styles.link} ${this.isSiblingUtilityBlock ? styles.utilityBlockSibling : ""}`}
      >
        <div className={styles.outerWrapper}>
          <div
            className={`${styles.innerWrapper}
                        ${this.state.isSectionInViewport ? "" : styles.fixed}
                        ${this.state.isTargetBlockInViewport ? styles.atTarget : ""}
                        ${this.isSiblingUtilityBlock ? styles.utilityBlockSibling : ""}`}
          >
            <div className={styles.content}>
              {this.scrollToBlockTitle && <h4 className={styles.title}>{this.scrollToBlockTitle}</h4>}
              {this.getButton()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Link.contextType = GlobalContext;

export default Link;
